export const VERSION: string = process.env.REACT_APP_VERSION || "0.1.0";